<template>
  <section>
    <div class="c-wrap c-wrap_short section-wrapper n-mt-5 n-mt-md-6">
      <div class="n-mb-2 n-mb-md-3 n-mb-lg-20">
        <div class="page-heading">
          <div class="page-heading__category">
            <nav class="breadcrumb">
              <ol class="breadcrumb__list">
                <li class="breadcrumb__item">
                  <a href="/media/news/"
                  ><div class="category in-special">
                    <div class="category__text">Новости</div>
                  </div></a
                  >
                </li>
                <li class="breadcrumb__item">
                  <a href="/media/medialibrary/"
                  ><div class="category in-special">
                    <div class="category__text">Медиатека</div>
                  </div></a
                  >
                </li>
              </ol>
            </nav>
          </div>
          <h1 class="page-heading__title page-title">
              {{item.name}}
          </h1>
        </div>
      </div>
      <div class="n-row n-mb-5 n-mb-lg-6">
        <div class="n-col-24 n-col-lg-12 d-flex align-items-center">
          <time class="n-small-text color-grey n-mr-20" :datetime="item.datetime">{{item.datetime_month}}</time>
        </div>
        <div class="n-col-lg-12 d-none d-lg-flex justify-content-end">
          <div class="sharing-bar">
            <div class="sharing-bar__title">Поделиться в&nbsp;соцсетях</div>
            <div class="sharing-bar__list">
              <a class="sharing-bar__item" :href="item.tg_link"
              ><svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.375 6.888c5.369-2.258 8.949-3.747 10.74-4.466C17.229.37 18.292.012 18.985 0c.152-.002.493.034.713.207a.74.74 0 0 1 .262.481c.025.139.055.454.031.7-.277 2.811-1.476 9.633-2.086 12.781-.259 1.333-.767 1.78-1.259 1.823-1.07.095-1.882-.682-2.917-1.338-1.621-1.025-2.537-1.664-4.11-2.665-1.818-1.156-.64-1.792.396-2.831.272-.272 4.984-4.41 5.075-4.785.011-.047.022-.222-.086-.314-.107-.092-.266-.06-.381-.036-.163.036-2.752 1.688-7.768 4.957-.735.487-1.4.724-1.997.712-.658-.014-1.923-.359-2.863-.654C.842 8.676-.075 8.485.005 7.87c.041-.32.498-.647 1.37-.982Z"
                  fill="none"
              /></svg></a
                ><a class="sharing-bar__item" :href="item.vk_link"
              ><svg width="19" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.81 6.435c.19-.362.862-1.4 1.368-2.172 1.517-2.284 1.794-2.767 1.794-3.056a.399.399 0 0 0-.396-.403H15.02c-.19.001-.352.14-.387.33-.197 1.11-2.757 4.296-3.16 4.497-.167 0-.396-.419-.396-1.207V1.03a.962.962 0 0 0-.19-.748C10.62 0 10.217 0 9.095 0 7.055 0 6.328.62 6.328 1.207a.374.374 0 0 0 .092.28.36.36 0 0 0 .264.122s.434.29.434 2.01a11.96 11.96 0 0 1-.102 2.012C6.012 5.446 4.62 2.896 3.958 1.06a.395.395 0 0 0-.396-.257H.402a.392.392 0 0 0-.308.142.407.407 0 0 0-.088.333c.443 2.43 5.46 9.982 8.693 9.982h1.58c.838 0 .901-.925.948-1.536.048-.611.087-.877.238-.877.49 0 1.493.885 2.149 1.464.656.58 1.082.95 1.406.95h1.976c1.02 0 1.976 0 1.976-.805 0-.306-.261-.66-1.763-2.413a52.14 52.14 0 0 1-1.398-1.609Z"
                  fill="none"
              /></svg
            ></a>
            </div>
          </div>
        </div>
      </div>



      <div class="photo-gallery js--fancybox-gallery" v-if="item.type === 'photo'">

        <div class="photo-gallery__item" v-for="(item,index) in item.photos" :key="index">
          <a :href="location + item" data-fancybox-gallery
          ><img
              class="media-library-image"
              :src="item"
              alt=""
          /></a>
        </div>

      </div>

      <div class="video-container" v-if="item.type === 'video'"><iframe :src="item.video_link"></iframe></div>

      <div class="d-block d-lg-none n-mt-3 n-mt-md-4">
        <div class="sharing-bar">
          <div class="sharing-bar__title">Поделиться в&nbsp;соцсетях</div>
          <div class="sharing-bar__list">
            <a class="sharing-bar__item" :href="item.tg_link"
            ><svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.375 6.888c5.369-2.258 8.949-3.747 10.74-4.466C17.229.37 18.292.012 18.985 0c.152-.002.493.034.713.207a.74.74 0 0 1 .262.481c.025.139.055.454.031.7-.277 2.811-1.476 9.633-2.086 12.781-.259 1.333-.767 1.78-1.259 1.823-1.07.095-1.882-.682-2.917-1.338-1.621-1.025-2.537-1.664-4.11-2.665-1.818-1.156-.64-1.792.396-2.831.272-.272 4.984-4.41 5.075-4.785.011-.047.022-.222-.086-.314-.107-.092-.266-.06-.381-.036-.163.036-2.752 1.688-7.768 4.957-.735.487-1.4.724-1.997.712-.658-.014-1.923-.359-2.863-.654C.842 8.676-.075 8.485.005 7.87c.041-.32.498-.647 1.37-.982Z"
                fill="none"
            /></svg></a
              ><a class="sharing-bar__item" :href="item.vk_link"
            ><svg width="19" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.81 6.435c.19-.362.862-1.4 1.368-2.172 1.517-2.284 1.794-2.767 1.794-3.056a.399.399 0 0 0-.396-.403H15.02c-.19.001-.352.14-.387.33-.197 1.11-2.757 4.296-3.16 4.497-.167 0-.396-.419-.396-1.207V1.03a.962.962 0 0 0-.19-.748C10.62 0 10.217 0 9.095 0 7.055 0 6.328.62 6.328 1.207a.374.374 0 0 0 .092.28.36.36 0 0 0 .264.122s.434.29.434 2.01a11.96 11.96 0 0 1-.102 2.012C6.012 5.446 4.62 2.896 3.958 1.06a.395.395 0 0 0-.396-.257H.402a.392.392 0 0 0-.308.142.407.407 0 0 0-.088.333c.443 2.43 5.46 9.982 8.693 9.982h1.58c.838 0 .901-.925.948-1.536.048-.611.087-.877.238-.877.49 0 1.493.885 2.149 1.464.656.58 1.082.95 1.406.95h1.976c1.02 0 1.976 0 1.976-.805 0-.306-.261-.66-1.763-2.413a52.14 52.14 0 0 1-1.398-1.609Z"
                fill="none"
            /></svg
          ></a>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
import modalGallery from '../../modules/modal-gallery'
export default {
  name: 'MediaLibraryDetail',
  props: ['data'],
  data(){
    return {
      item: JSON.parse(this.data),
      location: window.location.origin
    }
  },
  mounted(){
    console.log(JSON.parse(this.data))
    modalGallery()
  }
}
</script>